import { createContext } from 'react';
import noop from 'lodash/noop';

import api from '../api';
import { Category } from '../types';
import { Context } from '../../../types';

const CategoriesContext = createContext<Context<Category>>({
    get: api.get,
    getById: api.getById,
    getSchema: api.getSchema,
    schema: {},
    post: api.post,
    put: api.put,
    data: { ids: [], byId: {} },
    setData: noop,
    selected: null,
    setSelected: noop,
    remove: api.remove,
    error: null
});
CategoriesContext.displayName = 'CategoriesContext';
export default CategoriesContext;
